import { createRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { ProductForm } from '../components/productForm';
import { ProductList } from '../components/productList';
import { useDeleteProduct, useProducts, useSaveProduct } from '../hooks/useProducts';
import type { ProductFormData } from '../types/product';
import { protectedLayoutRoute } from './protectedLayout';

function PartsPage() {
  const [showForm, setShowForm] = useState(false);
  const [editingProduct, setEditingProduct] = useState<ProductFormData | null>(null);

  const { data: products = [], isLoading } = useProducts('parts');
  const saveMutation = useSaveProduct();
  const deleteMutation = useDeleteProduct();

  const handleSubmit = async (data: ProductFormData) => {
    saveMutation.mutate(data, {
      onSuccess: () => {
        setShowForm(false);
        setEditingProduct(null);
      },
    });
  };

  const handleEdit = (product: ProductFormData) => {
    setEditingProduct(product);
    setShowForm(true);
  };

  const handleDelete = (product: ProductFormData, onSuccess: () => void) => {
    if (!product.slug) return;
    deleteMutation.mutate({ slug: product.slug, category: 'parts' }, { onSuccess });
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingProduct(null);
  };

  if (showForm) {
    return (
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">
            {editingProduct ? 'Editar Peça/Acessório' : 'Nova Peça/Acessório'}
          </h1>
          <p className="mt-1 text-sm text-muted-foreground sm:text-base">
            {editingProduct
              ? 'Atualize as informações do item'
              : 'Adicione uma nova peça ou acessório'}
          </p>
        </div>
        <ProductForm
          initialData={editingProduct || { category: 'parts' }}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          lockedCategory
          isLoading={saveMutation.isPending}
        />
      </div>
    );
  }

  return (
    <ProductList
      products={products}
      isLoading={isLoading}
      category="parts"
      onAddNew={() => setShowForm(true)}
      onEdit={handleEdit}
      onDelete={handleDelete}
      isDeleting={deleteMutation.isPending}
    />
  );
}

export const partsRoute = createRoute({
  getParentRoute: () => protectedLayoutRoute,
  path: '/parts',
  component: PartsPage,
});
